var map = {
	"./HomeView.vue": [
		7192,
		373,
		63,
		150
	],
	"./Page/ContactView.vue": [
		5395,
		373,
		63,
		555
	],
	"./Page/ContentView.vue": [
		8567,
		373,
		63,
		823
	],
	"./Page/GameDetailView.vue": [
		7749,
		373,
		63,
		497
	],
	"./Page/GameView.vue": [
		6838,
		373,
		63,
		485
	],
	"./Page/IslamyatView.vue": [
		8425,
		373,
		63,
		389
	],
	"./Page/KidsView.vue": [
		1499,
		373,
		63,
		227
	],
	"./Page/KitchenView.vue": [
		2827,
		373,
		63,
		803
	],
	"./Page/NotFoundView.vue": [
		3991,
		722
	],
	"./Page/PlayView.vue": [
		229,
		229
	],
	"./Page/SearchView.vue": [
		5018,
		373,
		63,
		156
	],
	"./Page/SoundView.vue": [
		6249,
		373,
		63,
		866
	],
	"./User/LoginView.vue": [
		4051,
		51
	],
	"./User/ProfileView.vue": [
		3721,
		373,
		63,
		546
	],
	"./User/SubscribeView.vue": [
		9740,
		740
	],
	"./User/ThankYouView.vue": [
		795,
		795
	],
	"./User/UnsubscribeView.vue": [
		8241,
		270
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4235;
module.exports = webpackAsyncContext;